import script from "./database.vue?vue&type=script&setup=true&lang=js"
export * from "./database.vue?vue&type=script&setup=true&lang=js"

import "./database.vue?vue&type=style&index=0&id=2f75cede&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f75cede"]])

export default __exports__